import { ITableEmptyState } from '@models/Forms/IForms';
import { ITableEmptyStateAction, ITableEmptyStateProps } from '@srm/ui/table-empty-state';

/** Конфигурация может сузить действия, но не предоставить отсутствующие права. */
export const resolveTableEmptyState = (
    config: ITableEmptyState | undefined,
    viewMode: boolean,
    available: ITableEmptyStateAction[],
): ITableEmptyStateProps | undefined => {
    if (!config?.enabled) return undefined;
    const permitted = viewMode ? [] : available;
    const state = viewMode ? 'view' : permitted.length ? 'editable' : 'readonly';
    const variant = config.variants?.find((item) => item.state === state);
    const mode = variant?.actions?.mode ?? 'auto';
    const actions =
        mode === 'none'
            ? []
            : mode === 'custom'
              ? (variant?.actions?.items ?? [])
                    .flatMap((item, index, items) => {
                        const action =
                            permitted.find((candidate) => candidate.id === item.ref) ??
                            // прежний ref без id — первый доступный набор добавления из FormData
                            (item.ref === 'addFormDataRows'
                                ? permitted.find((candidate) => candidate.id.startsWith('addFormDataRows:'))
                                : undefined);
                        if (!action || items.findIndex((candidate) => candidate.ref === item.ref) !== index) return [];
                        return [{ ...action, label: item.label || action.label }];
                    })
                    // одно действие — одна кнопка, даже если на него ведут два ref
                    .filter((action, index, list) => list.findIndex((other) => other.id === action.id) === index)
              : permitted;
    if (state === 'editable' && mode === 'custom' && actions.length === 0) {
        return resolveTableEmptyState(config, false, []);
    }
    return {
        icon: config.icon,
        layout: config.layout === 'centered' ? 'centered' : 'inline',
        title: variant?.title || (state === 'editable' && actions.length ? 'Добавьте первую строку' : 'Нет данных'),
        description: variant?.description,
        actions,
    };
};
